module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/benchmarks.component.html
// module id = ../../../../../src/app/reports/myReports/benchmarks/benchmarks.component.html
// module chunks = main